<template>
  <div class="authority">
    <el-tree
      ref="authorityTree"
      :data="authorityTree"
      show-checkbox
      node-key="id"
      :check-strictly="strictly"
      @check-change="changeCheck"
      :props="defaultProps">
    </el-tree>
  </div>
</template>
<script>

export default {
  name: 'authority',
  props: {
    authorityTree: {
      type: Array
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      strictly: true
    };
  },
  methods: {
    changeCheck() {
      let checkedArr = this.$refs.authorityTree.getCheckedNodes();
      let functionIds = [];
      let resourceIds = [];
      checkedArr.forEach(data => {
        if (data.children) {
          functionIds.push(data.id);
        }
        else {
          resourceIds.push(data.id);
        }
      });
      this.$emit('checkedArr', { functionIds, resourceIds });
    }
  }
};
</script>
<style lang="scss" >
.authority{
  padding-top: 10px;
}
</style>
